import React, { Component } from 'react';
import { ListEvents, ListCompetitions, ListTeams } from './graphql.js';
import CompetitorsComponent from '../../components/Competitors';
import { gqlOperation, logError, updateInPath, parseAwsJsonInArr } from '../../../../common/utils';

export default class Teams extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      events: [],
      competitions: []
    };
  }

  fetchTeams = (e, { value }) => {
    gqlOperation(ListTeams, { competitionId: value })
      .then(({ listRegisteredTeams }) => {
        const data = parseAwsJsonInArr(listRegisteredTeams.items, ['mentor']);
        this.setState(prevState => updateInPath(prevState, 'data', data));
      })
      .catch(logError);
  }

  fetchEvents = () => {
    gqlOperation(ListEvents, {})
      .then(({ listEvents }) => {
        this.setState(prevState => updateInPath(prevState, 'events', listEvents) );
      })
      .catch(logError);
  }

  fetchCompetitions = (e, {value}) => {
    gqlOperation(ListCompetitions, { eventId: value })
      .then(({ listEventCompetitions }) => {
        const data = parseAwsJsonInArr(listEventCompetitions, ['text']);
        this.setState(prevState => updateInPath(prevState, 'competitions', data));
      })
      .catch(logError);
  }
  
  componentDidMount() {
    this.fetchEvents();
  }

  render() {
    const { events, competitions, data } = this.state;

    return (
      <CompetitorsComponent
        data={data}
        events={events}
        competitions={competitions}
        onSelectEvent={this.fetchCompetitions}         
        onSelectCompetition={this.fetchTeams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/user/containers/Competitors/index.js